import React from 'react';
import {
  Box, Typography, FormControl, InputLabel, Select, MenuItem,
  RadioGroup, FormControlLabel, Radio, Checkbox,
  Paper, IconButton, Stack
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

const FavoritesSidebar = ({ categories, filters, setFilters }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: '16px', border: '1px solid #F0F0F0' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" color="primary">Filtrar</Typography>
        <IconButton size="small">
          <FilterListIcon />
        </IconButton>
      </Stack>

      <Box sx={{ mb: 4 }}>
        <Typography variant="caption" fontWeight="bold" color="#737791" sx={{ mb: 1, display: 'block', textTransform: 'uppercase' }}>
          Categoría
        </Typography>
        <FormControl fullWidth size="small">
          <Select
            name="category"
            value={filters.category || ''}
            onChange={handleChange}
            displayEmpty
            sx={{ borderRadius: '8px' }}
          >
            <MenuItem value="">Todas las categorías</MenuItem>
            {categories.map(cat => (
              <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="caption" fontWeight="bold" color="#737791" sx={{ mb: 1, display: 'block', textTransform: 'uppercase' }}>
          Ordenar por
        </Typography>
        <RadioGroup name="sort" value={filters.sort || 'recent'} onChange={handleChange}>
          <FormControlLabel
            value="recent"
            control={<Radio size="small" sx={{ color: '#D1D5DB', '&.Mui-checked': { color: 'primary.main' } }} />}
            label="Recién añadidos"
            sx={{ '& .MuiTypography-root': { fontSize: '14px', color: '#737791' } }}
          />
          <FormControlLabel
            value="rating"
            control={<Radio size="small" sx={{ color: '#D1D5DB', '&.Mui-checked': { color: 'primary.main' } }} />}
            label="Mejor calificación"
            sx={{ '& .MuiTypography-root': { fontSize: '14px', color: '#737791' } }}
          />
        </RadioGroup>
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold" color="#737791" sx={{ mb: 1, display: 'block', textTransform: 'uppercase' }}>
          Tipo de servicio
        </Typography>
        <Stack spacing={0.5}>
          <FormControlLabel
            control={
              <Checkbox 
                size="small" 
                checked={!!filters.showServices} 
                onChange={(e) => setFilters(prev => ({ ...prev, showServices: e.target.checked }))}
                sx={{ color: '#D1D5DB', '&.Mui-checked': { color: 'primary.main' } }} 
              />
            }
            label="Solo Servicios"
            sx={{ '& .MuiTypography-root': { fontSize: '14px', color: '#737791' } }}
          />
          <FormControlLabel
            control={
              <Checkbox 
                size="small" 
                checked={!!filters.showPages} 
                onChange={(e) => setFilters(prev => ({ ...prev, showPages: e.target.checked }))}
                sx={{ color: '#D1D5DB', '&.Mui-checked': { color: 'primary.main' } }} 
              />
            }
            label="Páginas de Servicios"
            sx={{ '& .MuiTypography-root': { fontSize: '14px', color: '#737791' } }}
          />
        </Stack>
      </Box>
    </Paper>
  );
};

export default FavoritesSidebar;
